import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";

/* eslint-disable no-await-in-loop, no-constant-condition */
function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

export function retry(_x) {
  return _retry.apply(this, arguments);
}

function _retry() {
  _retry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(func) {
    var _ref,
        _ref$maxAttempts,
        maxAttempts,
        _ref$maxDelayMs,
        maxDelayMs,
        delay,
        attempts,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref$maxAttempts = _ref.maxAttempts, maxAttempts = _ref$maxAttempts === void 0 ? 10 : _ref$maxAttempts, _ref$maxDelayMs = _ref.maxDelayMs, maxDelayMs = _ref$maxDelayMs === void 0 ? 60 * 1000 : _ref$maxDelayMs;
            delay = 1000;
            attempts = 0;

          case 3:
            if (!true) {
              _context.next = 20;
              break;
            }

            _context.prev = 4;
            _context.next = 7;
            return func();

          case 7:
            return _context.abrupt("return", _context.sent);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            attempts += 1;

            if (!(attempts >= maxAttempts)) {
              _context.next = 15;
              break;
            }

            throw _context.t0;

          case 15:
            delay = Math.min(delay * Math.pow(2, attempts - 1), maxDelayMs);
            _context.next = 18;
            return wait(delay);

          case 18:
            _context.next = 3;
            break;

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _retry.apply(this, arguments);
}